import {
    Component,
    ElementRef,
    EventEmitter,
    HostListener,
    Input,
    Output,
} from '@angular/core';

@Component({
    selector: 'app-used-titles-suggestions',
    templateUrl: './used-titles-suggestions.component.html',
    styleUrls: ['./used-titles-suggestions.component.scss'],
    standalone: false
})
export class UsedTitlesSuggestionsComponent {
    @Input() titleList: string[]
    @Output() onHideSuggestions: EventEmitter<void> = new EventEmitter();
    @Output() onTitleSelected: EventEmitter<string> = new EventEmitter();

    constructor(private eRef: ElementRef) {}

    @HostListener('document:click', ['$event'])
    clickOut(event: any) {
        if (!this.eRef.nativeElement.contains(event.target)) {
            this.onHideSuggestions.emit();
        }
    }

    selectTile(title) {
      this.onTitleSelected.emit(title)
      this.onHideSuggestions.emit();
    }
}
